import { CategoriesSlice } from '.'
import { AppDispatch } from '../../index'
import { qrMenuGET } from 'featureSliced/shared/api/qrMenu/GET'
import { getCategoriesFiltered } from 'featureSliced/shared/utils/getCategoriesFiltered'
import { handlePromiseAll } from 'featureSliced/shared/utils/handlePromiseAll'
import { AppSlice } from '../AppReducer'
import { errorHandler } from 'components/ErrorHandler'

export const getSoldOutItems = () => async (dispatch: AppDispatch) => {
  const response = await qrMenuGET.getSoldOutItems()
  const soldOutIds: number[] =
    response?.map((item: { articleId: number }) => item?.articleId) || []
  dispatch(CategoriesSlice.actions.setSoldOutIds(soldOutIds))
  return soldOutIds
}

export const getCategoriesData = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(CategoriesSlice.actions.setIsLoading(true))

    const [categories, soldOutItems] = await handlePromiseAll([
      qrMenuGET.products_v2,
      qrMenuGET.getSoldOutItems,
    ])

    const soldOutIds: number[] =
      soldOutItems?.data?.map(
        (item: { articleId: number }) => item?.articleId
      ) || []

    const categoriesFiltered = getCategoriesFiltered(categories, soldOutIds)

    dispatch(AppSlice.actions.setIsProductsLoaded(true))
    dispatch(CategoriesSlice.actions.setCategories(categoriesFiltered))
    dispatch(CategoriesSlice.actions.setSoldOutIds(soldOutIds))
    dispatch(CategoriesSlice.actions.setIsLoaded())
    dispatch(CategoriesSlice.actions.setIsLoading(false))
  } catch (e) {
    errorHandler(e)
  }
}
